<template>
  <div>
    <UIExit label="Exit Control Panel" :exit-url="defaultRedirect" />
    <router-view></router-view>
  </div>
</template>

<script>
import ROUTE from '@/src/constants/route-constants.js'
import { mapActions, mapGetters, mapState } from 'vuex'
import layoutConstants from '@src/constants/layout-constant.js'
import { SCOPE_LEVELS, ENV } from '@src/constants/general-constants.js'
import UIExit from '@src/components/UiElements/UIExit.vue'
import { TENANT_ROLES } from '@src/constants/user-roles-constants.js'
import { FEATURES_ENVIRONMENT } from '@src/services/.env.js'
import { MYQAMPUS_FEATURE_NAMES } from '@/src/constants/feature-name-constants.js'
export default {
  name: 'ControlPanelLayout',
  components: {
    UIExit,
  },
  beforeRouteUpdate(to, from, next) {
    this.modifyLeftBarDropdown(to.name)
    next()
  },
  page: {
    title: ' Control Panel',
    meta: [
      {
        name: 'description',
        content: ' Control Panel',
      },
    ],
  },
  data() {
    return {
      defaultRedirect: ROUTE.QUICK_ACTION.PATH,
    }
  },
  computed: {
    ...mapGetters('auth', ['isOwner']),
    ...mapState('featureNaming', ['routerList']),
  },
  watch: {
    routerList: {
      handler() {
        this.setLeftbarContent({
          back: '',
          customeHeader: 'left-bar-class-list',
          defaultRoute: 'general-settings',
          SHOW_SECTION_DROPDOWN_TO: layoutConstants.showSectionDropdownTo,
          SHOW_CLASS_DROPDOWN_TO: layoutConstants.showClassDropdownTo,
          routes: [
            /* SYSTEM SETTINGS */
            {
              id: '3',
              icon: 'systemSetting',
              name: 'SYSTEM_SETTINGS',
              basedOn: [SCOPE_LEVELS.ROOT_LEVEL, SCOPE_LEVELS.CAMPUS_LEVEL],
              role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
              showChilds: false,
              routesName: [
                'general-settings',
                'contact-settings',
                'billing-settings',
                'site-settings',
                'fee-system-settings',
              ],
              childs: [
                {
                  name: 'Site Settings',
                  route: { name: 'site-settings' },
                  basedOn: [SCOPE_LEVELS.ROOT_LEVEL],
                },
                {
                  name: 'General Settings',
                  route: { name: 'general-settings' },
                  basedOn: [SCOPE_LEVELS.ROOT_LEVEL, SCOPE_LEVELS.CAMPUS_LEVEL],
                },

                {
                  name: 'CONTACT_SETTINGS',
                  route: { name: 'contact-settings' },
                },
                {
                  name: 'Billing Settings',
                  route: { name: 'billing-settings' },
                },
              ],
            },
            {
              id: '5',
              icon: 'featureSetting',
              name: 'FEATURE_SETTINGS',
              role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
              showChilds: false,
              routesName:
                FEATURES_ENVIRONMENT === ENV.PROD
                  ? [
                      'pickup-feature-settings',
                      'class-feature-settings',
                      'section-feature-settings',
                    ]
                  : [
                      'pickup-feature-settings',
                      'campus-attendance-feature-settings',
                      'period-attendance-feature-settings',
                      'section-attendance-feature-settings',
                      'syllabus-automator-feature-settings',
                      'fee-feature-settings',
                      'staff-feature-settings',
                      'syllabus-feature-settings',
                      'schedule-feature-settings',
                      'lesson-planner-feature-settings',
                      'teacher-feature-settings',
                      // 'exam-feature-settings',
                      'time-table-feature-settings',
                      'daily-student-attendance-feature-settings',
                      'class-feature-settings',
                      'support-query-feature-settings',
                      'section-feature-settings',
                      'exam-planner-feature-settings',
                      'pickup-person-feature-settings',
                      'student-feature-settings',
                      'guardian-feature-settings',
                    ],
              childs:
                FEATURES_ENVIRONMENT === ENV.PROD
                  ? [
                      {
                        name: this.routerList.CLASSES.NAME,
                        displayName: this.routerList.CLASSES.DISPLAY_NAME,
                        route: { name: 'class-feature-settings' },
                      },
                      {
                        name: 'SECTION',
                        displayName: this.routerList.SECTIONS.DISPLAY_NAME,
                        basedOn: [
                          SCOPE_LEVELS.CAMPUS_LEVEL,
                          SCOPE_LEVELS.SECTION_LEVEL,
                          SCOPE_LEVELS.ROOT_LEVEL,
                        ],
                        route: { name: 'section-feature-settings' },
                      },
                      {
                        name: 'PICKUP_SETTINGS',
                        route: { name: 'pickup-feature-settings' },
                      },
                    ]
                  : [
                      {
                        name: this.routerList.CLASSES.NAME,
                        displayName: this.routerList.CLASSES.DISPLAY_NAME,
                        route: { name: 'class-feature-settings' },
                      },
                      {
                        name: 'SECTION',
                        displayName: this.routerList.SECTIONS.DISPLAY_NAME,
                        basedOn: [
                          SCOPE_LEVELS.CAMPUS_LEVEL,
                          SCOPE_LEVELS.SECTION_LEVEL,
                          SCOPE_LEVELS.ROOT_LEVEL,
                        ],
                        route: { name: 'section-feature-settings' },
                      },
                      {
                        name: 'STUDENT',
                        route: { name: 'student-feature-settings' },
                      },
                      {
                        name: 'TEACHER',
                        route: { name: 'teacher-feature-settings' },
                      },
                      {
                        name: 'STAFF',
                        route: { name: 'staff-feature-settings' },
                      },
                      {
                        name: 'GUARDIAN',
                        route: { name: 'guardian-feature-settings' },
                      },
                      {
                        name: 'PICKUP_PERSON',
                        route: { name: 'pickup-person-feature-settings' },
                      },
                      {
                        name: 'CAMPUS_ATTENDANCE',
                        route: { name: 'campus-attendance-feature-settings' },
                      },
                      {
                        name: 'PERIOD_ATTENDANCE',
                        route: { name: 'period-attendance-feature-settings' },
                      },
                      {
                        name: 'SECTION_ATTENDANCE',
                        route: { name: 'section-attendance-feature-settings' },
                      },
                      {
                        name: 'DAILY_STUDENT_ATTENDANCE',
                        route: { name: 'daily-student-attendance-feature-settings' },
                      },
                      {
                        name: 'FEE',
                        route: { name: 'fee-feature-settings' },
                      },
                      {
                        name: 'LESSON_PLANNER',
                        route: { name: 'lesson-planner-feature-settings' },
                      },
                      {
                        name: MYQAMPUS_FEATURE_NAMES.TIME_TABLE_MANAGER,
                        route: { name: 'time-table-feature-settings' },
                      },
                      {
                        name: 'SYLLABUS_AUTOMATOR',
                        route: { name: 'syllabus-automator-feature-settings' },
                      },
                      {
                        name: MYQAMPUS_FEATURE_NAMES.SYLLABUS_MANAGER,
                        route: { name: 'syllabus-feature-settings' },
                      },
                      {
                        name: 'SCHEDULE',
                        route: { name: 'schedule-feature-settings' },
                      },
                      // {
                      //   name: 'EXAM',
                      //   basedOn: [
                      //     SCOPE_LEVELS.CAMPUS_LEVEL,
                      //     SCOPE_LEVELS.SECTION_LEVEL,
                      //     SCOPE_LEVELS.ROOT_LEVEL,
                      //   ],
                      //   route: { name: 'exam-feature-settings' },
                      // },
                      {
                        name: 'EXAM_PLANNER',
                        route: { name: 'exam-planner-feature-settings' },
                      },
                      {
                        name: 'PICKUP_SETTINGS',
                        route: { name: 'pickup-feature-settings' },
                      },
                      {
                        name: 'SUPPORT_QUERY',
                        route: { name: 'support-query-feature-settings' },
                      },
                    ],
            },
            /* Payment Options */
            {
              id: '6',
              icon: 'dashboard',
              name: 'Promotion',
              route: { name: 'promote' },
              role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
              basedOn: [SCOPE_LEVELS.SECTION_LEVEL],
            },
            {
              id: '10',
              icon: 'featureManager',
              name: 'FEATURE_MANAGER',
              route: { name: 'features-manager' },
              role: [TENANT_ROLES.SUPER_ADMIN, TENANT_ROLES.CAMPUS_ADMIN],
              basedOn: [SCOPE_LEVELS.ROOT_LEVEL, SCOPE_LEVELS.CAMPUS_LEVEL],
            },

            {
              id: '8',
              icon: 'dashboard',
              name: 'Add Payment Method',
              role: [TENANT_ROLES.SUPER_ADMIN],
              route: { name: 'payment-methods' },
              basedOn: [SCOPE_LEVELS.ROOT_LEVEL],
            },
            {
              id: '008',
              icon: 'ownership',
              isRenderForcefully: this.isOwner,
              name: 'OWNERSHIP',
              route: { name: 'ownership' },
            },

            /* ad-ons */

            {
              id: '009',
              name: 'AD_ONS',
              icon: 'Add-ons',
              basedOn: [SCOPE_LEVELS.ROOT_LEVEL, SCOPE_LEVELS.CAMPUS_LEVEL],
              role: [TENANT_ROLES.SUPER_ADMIN],
              showChilds: false,
              routesName: [
                'sms-add-ons',
                'email-add-ons',
                'email-provider-detail-page',
                'sms-provider-detail-page',
              ],
              childs: [
                {
                  name: 'SMS_AD_ONS',
                  route: { name: 'sms-add-ons' },
                },
                {
                  name: 'EMAIL_AD_ONS',
                  route: { name: 'email-add-ons' },
                },
                {
                  name: 'EMAIL_AD_ONS_DETAIL',
                  route: { name: 'email-provider-detail-page' },
                  isDynamicRoute: true,
                },
                {
                  name: 'SMS_AD_ONS_DETAIL',
                  route: { name: 'sms-provider-detail-page' },
                  isDynamicRoute: true,
                },
              ],
            },
            {
              id: '0010',
              icon: 'billingPayment',
              name: 'billing-payment',
              role: [TENANT_ROLES.SUPER_ADMIN],
              route: { name: 'billing-payment' },
              basedOn: [SCOPE_LEVELS.ROOT_LEVEL],
            },
          ],
        })
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    let isUpper = !this.currentCampusScope
    this.fetchFeatureRename(isUpper)
  },
  methods: {
    ...mapActions('featureNaming', ['fetchFeatureRename']),
    ...mapActions('layout', ['setLeftbarContent', 'modifyLeftBarDropdown']),
  },
}
</script>
